export default __webpack_public_path__ + "static/pc01-8f1c5810351116627f6e95eb585ecfeb.png";